import { render, staticRenderFns } from "./BookBuilder.vue?vue&type=template&id=e55607c0&"
import script from "./BookBuilder.vue?vue&type=script&lang=ts&"
export * from "./BookBuilder.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports